var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPuntoEnApagado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218.62 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-punto-en-apagado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "punto_en_apagado"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.59,192.32c0,42.39,3.14,45.14,35.72,47.49v15.31H0V239.81c26.69-2.35,29.83-5.1,29.83-47.49V62.8c0-42.39-3.14-45.14-27.87-47.49V0H116.57c36.89,0,58.48,5.49,74.18,16.88C207.63,29,218.62,47.1,218.62,73.4c0,52.59-39.25,79.67-83.21,83.6-4.32.39-8.24.39-11.38.39l-29.44-6.67Zm0-61.23a53.86,53.86,0,0,0,16.88,3.14c12.56,0,36.89-9.42,36.89-61.23,0-40.82-22.37-53.38-40-53.38-13,0-13.74,2-13.74,14.13Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPuntoEnApagado);
export default __webpack_public_path__ + "static/media/ic-punto-en-apagado.f176847a7816c5fb405849f25f0d4df3.svg";
export { ForwardRef as ReactComponent };